import { AppContext } from '@/contexts/app.context';
import { UserDTO } from '@/generated';
import { userApi } from '@/generated/clients';
import { isAdminUser } from '@/utils/user';
import { useContext, useEffect, useState } from 'react';

export const useAdminAllUsers = () => {
  const [userList, setUserList] = useState<Array<UserDTO>>();
  const context = useContext(AppContext);

  useEffect(() => {
    if (!userList && isAdminUser(context.state?.userProfile)) {
      const getUsers = async () => {
        const users = await userApi.userListUsers();
        setUserList(users);
      };
      getUsers();
    }
  }, []);
  return { userList };
};
